var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.navs && _vm.navs.length)?_c('div',{ref:"headerRef",staticClass:"app-header"},[_c('div',{staticClass:"main-width"},[_c('AppTopbar'),_vm._v(" "),_c('AppNav',{attrs:{"navs":_vm.navs}})],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }